import { render, staticRenderFns } from "./DuplicateViews.vue?vue&type=template&id=4524d242&scoped=true&"
import script from "./DuplicateViews.vue?vue&type=script&lang=js&"
export * from "./DuplicateViews.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateViews.vue?vue&type=style&index=0&id=4524d242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4524d242",
  null
  
)

export default component.exports